export const DemoTeleUserEmail = 'john.doe@melatech.io';
